import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { TallLayout } from "common/components/layouts/TallLayout";
import { H1 } from "common/components/Typography";
import React from "react";
import { ContentBreadcrumbFragment_context } from "__generated__/types";
import { ContentNotWide } from "./ContentNotWide";

interface Props {
  title: string;
  context?: ContentBreadcrumbFragment_context[];
  breadcrumbItems?: BreadcrumbItem[];
  isAdmin?: boolean;
}

export const NormalContentLayout: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  context = [],
  isAdmin = true,
  children,
}) => {
  return (
    <TallLayout context={context} isAdmin={isAdmin}>
      <H1>{title}</H1>
      <ContentNotWide>{children}</ContentNotWide>
    </TallLayout>
  );
};
